import Menu from '@/global/components/MenuV2'
import { FormField } from 'global/components/Form'
import { Link } from 'global/components/Link'
import Dialog from 'global/guides/Dialog'
import { useAuth } from 'hooks'
import { KeyRoundIcon } from 'lucide-react'
import React from 'react'
import { SubmitHandler } from 'react-hook-form'
import { auth, AvaliacaoSchema } from 'service/api'
import { toast } from 'sonner'
import { z } from 'zod'
import { create } from 'zustand'

interface State {
    open: boolean
    toggle: () => void
}

interface FormData {
    novaSenha: string
    senhaAnterior: string
    confirmarNovaSenha: string
}

const store = create<State>(set => ({
    open: false,
    toggle: () => set(state => ({ open: !state.open })),
}))

export function AlterarSenhaLink({ children }: { children: React.ReactNode }) {
    const toggle = store(state => state.toggle)

    return (
        <Link
            onClick={toggle}
            sx={{
                cursor: 'pointer',
            }}
        >
            {children}
        </Link>
    )
}

export const AlterarSenhaMenuItem: React.FC = () => {
    const toggle = store(state => state.toggle)

    return (
        <Menu.Item onClick={toggle}>
            <Menu.Item.Icon>
                <KeyRoundIcon />
            </Menu.Item.Icon>
            <Menu.Item.Text>Alterar senha</Menu.Item.Text>
        </Menu.Item>
    )
}

const AlterarSenha: React.FC = () => {
    const { decoded } = useAuth()
    const open = store(state => state.open)
    const toggle = store(state => state.toggle)

    const handleSubmit: SubmitHandler<FormData> = data =>
        auth
            .post(`${decoded.sub}/alterar-senha`, data)
            .then(() => {
                toast.success('Senha alterada com sucesso')
                toggle()
            })
            .catch(({ response: { data } }) => {
                toast.error(data.message)
            })

    return (
        <Dialog.Root
            open={open}
            onClose={toggle}
            width="30rem"
            height="fit-content"
            onSubmit={handleSubmit}
            schema={z
                .object({
                    novaSenha: AvaliacaoSchema.shape.senha,
                    senhaAnterior: AvaliacaoSchema.shape.confirme,
                    confirmarNovaSenha: AvaliacaoSchema.shape.confirme,
                })
                .refine(data => data.novaSenha === data.confirmarNovaSenha, {
                    message: 'As senhas não coincidem',
                    path: ['confirmarNovaSenha'],
                })}
        >
            <Dialog.Title>Alterar senha</Dialog.Title>
            <Dialog.Content dividers>
                <FormField
                    label="Senha anterior"
                    name="senhaAnterior"
                    type="password"
                    required
                />
                <FormField
                    label="Nova senha"
                    name="novaSenha"
                    type="password"
                    required
                />
                <FormField
                    label="Confirmar nova senha"
                    name="confirmarNovaSenha"
                    type="password"
                    required
                />
            </Dialog.Content>
            <Dialog.Actions>
                <Dialog.Actions.SecondaryButton />
                <Dialog.Actions.PrimaryButton />
            </Dialog.Actions>
        </Dialog.Root>
    )
}

export default AlterarSenha
